import { combineReducers } from "redux";
import LayoutReducer from "./LayoutReducer";
import DataReducer from "./DataReducer";
import AuthReducer from "./AuthReducer";
import MessageReducer from "./MessageReducer";
import TwoFactor from "./TwoFactor";
import Workflow from "./workflow";
import SideNavReducer from "./SideNavReducer";
import TeamPlanReducer from "./TeamPlanReducer";

export default combineReducers({
  LayoutReducer,
  DataReducer,
  AuthReducer,
  MessageReducer,
  TwoFactor,
  Workflow,
  SideNavReducer,
  TeamPlanReducer,
});
